module.exports = "/_next/static/images/Savings-7dfc6b1c21f4c136c595cbf3507df0db.png";